export default "__VITE_ASSET__DmAVOT7c__"